<main>
  <h2>PPS - Let's work!</h2>

  <div class="clr-row" >
    <div class="clr-col-6">
      <app-my-projects-card *ngIf="checker" [childMessage]="'0'" [projectID]="'0'" [employeeID]="'0'"></app-my-projects-card>
    </div>
    <div class="clr-col-6">
      <app-comment-project-card [projectId]="'null'" [staffId]="staffId"></app-comment-project-card>
    </div>
  </div>
</main>
